module.exports = __webpack_public_path__ + "img/other.f80da5a9.png";